import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ClickAwayListener, Paper, Popover, Popper, } from "@mui/material";
import { noop } from "lodash-es";
import React from "react";
import { useDebouncedValue } from "../hooks/useDebouncedValue.js";
function _PopoverOpenButton({ children, content, popoverRef, onOpen, onClose, ...props }, ref) {
    // FIXME
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [anchorEl, setAnchorEl] = React.useState(null);
    // FIXME
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useImperativeHandle(popoverRef, () => ({
        handleClose() {
            onClose?.({}, "backdropClick");
            setAnchorEl(null);
        },
    }), [onClose]);
    const buttonWithOpen = React.cloneElement(children, {
        onClick: (e) => {
            onOpen?.();
            children.props.onClick?.(e);
            setAnchorEl(e.currentTarget);
        },
        ref,
    });
    return (_jsxs(_Fragment, { children: [buttonWithOpen, _jsx(Popover, { disableAutoFocus: true, disableEnforceFocus: true, disableEscapeKeyDown: true, disableRestoreFocus: true, disableScrollLock: true, open: Boolean(anchorEl), anchorEl: anchorEl, onClose: (e, reason) => {
                    e?.preventDefault();
                    e?.stopPropagation();
                    onClose?.(e, reason);
                    setAnchorEl(null);
                }, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "center",
                }, ...props, slotProps: {
                    paper: { sx: { my: 0.5 } },
                }, children: content })] }));
}
// a mobile-friendly version of popover which is not stealing focus, and just open absolutely positioned popover
function _PopperPopoverOpenButton({ children, content, popoverRef, paperProps, modifiers, placement, onOpen, onClose, keepMounted = false, sx, }, ref) {
    // FIXME
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [anchorEl, setAnchorEl] = React.useState(null);
    // FIXME
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useImperativeHandle(popoverRef, () => ({
        handleClose() {
            onClose?.();
            setAnchorEl(null);
        },
    }), [onClose]);
    const buttonWithOpen = React.cloneElement(children, {
        onClick: (e) => {
            onOpen?.();
            children.props.onClick?.(e);
            setAnchorEl(e.currentTarget);
        },
        ref,
    });
    return (_jsxs(_Fragment, { children: [buttonWithOpen, _jsx(PopperPopover, { open: Boolean(anchorEl), anchorEl: anchorEl, onClose: e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClose?.();
                    setAnchorEl(null);
                }, paperProps: paperProps, modifiers: modifiers, placement: placement, keepMounted: keepMounted, sx: sx, children: content })] }));
}
function PopperPopover({ anchorEl, open, onClose, children, paperProps, modifiers, placement, disablePortal = true, keepMounted = false, sx, }) {
    const openDebounced = useDebouncedValue(open, 250);
    return (_jsx(Popper, { open: open, anchorEl: anchorEl, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, placement: placement, sx: sx, children: _jsx(ClickAwayListener, { onClickAway: open && openDebounced ? onClose : noop, mouseEvent: "onClick", touchEvent: "onTouchEnd", children: _jsx(Paper, { ...paperProps, children: children }) }) }));
}
export const PopoverOpenButton = React.memo(React.forwardRef(_PopoverOpenButton));
export const PopperPopoverOpenButton = React.memo(React.forwardRef(_PopperPopoverOpenButton));
//# sourceMappingURL=PopoverOpenButton.js.map